/* global APP_GIT_HASH */
import { TrackJS } from "trackjs";

import {
  TRACK_JS_APPLICATION_KEY,
  TRACK_JS_TOKEN,
} from "helpers/error_reporting/constants";
import { isDevEnvironment } from "helpers/get_env";

const initErrorReporting = (sessionId: string) => {
  if (TrackJS && !TrackJS.isInstalled() && !isDevEnvironment()) {
    TrackJS.install({
      token: TRACK_JS_TOKEN,
      application: TRACK_JS_APPLICATION_KEY,
      version: APP_GIT_HASH,
    });
    TrackJS.configure({ sessionId });
  }
};

const addMetadata = (key: string, value: string) => {
  if (TrackJS && TrackJS.isInstalled()) {
    TrackJS.addMetadata(key, value);
  }
};

const reportError = (
  error: Error | object | string,
  metadata?: Record<string, string>
) => {
  if (metadata) {
    Object.entries(metadata).forEach(([key, value]) => {
      addMetadata(key, value);
    });
  }
  if (TrackJS && TrackJS.isInstalled()) {
    TrackJS.track(error);
  }
};

const ERROR_REPORTING_CONSOLE = TrackJS.console;

export {
  addMetadata,
  ERROR_REPORTING_CONSOLE,
  initErrorReporting,
  reportError,
};
